<template>
  <div>
    <!-- MODAL PALETTE SHARE -->
    <div class="modal fade" :id="id" tabindex="-1" :aria-labelledby="id + 'Label'" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title typography-headline-md" :id="id + 'Label'">Share {{ palette.name }}</p>
            <button type="button" class="btn-close img-logo" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body text-center">
            <div class="row justify-content-center mb-5">
              <div class="col-md-8">
                <p class="typography-headline-sm">Share this palette with your social timeline or friends ✨</p>
              </div>
            </div>

            <div class="row mb-5">
              <div class="col-md-12">
                <!-- TWITTER -->
                <a :href="'https://twitter.com/intent/tweet?source=https%3A%2F%2Fcolorffy.com%2Fpalettes%2F' + palette.id + '&text=Check this awesome palette ' + palette.name + ':%20https%3A%2F%2Fcolorffy.com%2Fpalettes%2F' + palette.id"
                   target="_blank" title="Tweet" class="icon-svg-wrap svg-twitter">
                  <img src="@/assets/img/icons/twitter-fill.svg" class="img-fluid" width="30px" alt="Twitter Share">
                </a>

                <!-- PINTEREST -->
                <a :href="'https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fcolorffy.com%2Fpalettes%2F' + palette.id + '&description=Check%20this%20awesome%palette ' + palette.name"
                   target="_blank" title="Pin it" class="icon-svg-wrap svg-pinterest">
                  <img src="@/assets/img/icons/pinterest-fill.svg" class="img-fluid" width="30px" alt="Pinterest Share">
                </a>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <i class="material-icons-outlined text-secondary mdc-28 mb-2">add_link</i>
                <p class="typography-headline-sm">Or click to copy this link:</p>
                <a class="text-underline user-select-all" @click="copyURL">
                  <pre class="bg-default border-radius-12 py-2">https://colorffy.com/palettes/{{ palette.id }}</pre>
                </a>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-link ripple ripple-primary" data-bs-dismiss="modal">Close</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalPaletteShare',
  props: [
    'palette',
    'id',
  ],
  methods: {
    copyURL() {
      this.$clipboard('https://colorffy.com/palettes/' + this.palette.id)
      this.$swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        icon: 'success',
        title: 'Link copied',
      })
    }
  }
}
</script>